import { gql } from 'apollo-angular';

export var nav_search_all = gql`
  query navSearchAll($searchLike: String!, $search: String!, $limit: Int!) {
    search_projects(
      first: $limit
      name: $searchLike
      orderByInstr: [{ column: NAME, search: $search, order: ASC }]
    ) {
      data {
        id
        name
        projectStatuses {
          status_sequence_id
          active
          is_primary
        }
        participants(
          hasRole: { column: NAME, operator: EQ, value: "Developer" }
        ) {
          organization {
            name
          }
          person {
            name
          }
        }
      }
    }
    search_funds(
      first: $limit
      name: $searchLike
      orderByInstr: [{ column: NAME, search: $search, order: ASC }]
    ) {
      data {
        id
        name
      }
    }
    search_sponsors(
      first: $limit
      name: $searchLike
      orderByInstr: [{ column: NAME, search: $search, order: ASC }]
    ) {
      data {
        id
        name
      }
    }
    search_organizations(
      first: $limit
      name: $searchLike
      orderByInstr: [{ column: NAME, search: $search, order: ASC }]
    ) {
      data {
        id
        name
      }
    }
    search_people(
      first: $limit
      name: $searchLike
      orderByInstr: [{ column: NAME, search: $search, order: ASC }]
    ) {
      data {
        id
        name
      }
    }
    search_owned_entities(
      first: $limit
      name: $searchLike
      orderByInstr: [{ column: NAME, search: $search, order: ASC }]
    ) {
      data {
        id
        name
        project {
          name
          id
        }
      }
    }
  }
`;
